import { ConsumationType } from '@customTypes/types';
import { z } from 'zod';

export const workingConditionsFormSchema = z.object({
  consummationType: z.nativeEnum(ConsumationType),
  choreographerPresence: z.boolean(),
  photoshootMandatory: z.boolean(),
  artistsPerShift: z.number({ message: 'Enter quantity' }).optional(),
  numberOfStages: z.number({ message: 'Enter quantity' }).optional(),
  numberOfPolesDynamic: z.number({ message: 'Enter quantity' }).optional(),
  numberOfPolesStatic: z.number({ message: 'Enter quantity' }).optional(),
  experienceRequired: z.boolean(),
  artistTraining: z.boolean(),
  dressCodes: z.array(z.string()),
  additionalInformation: z
    .string()
    .min(100, { message: 'minimum number of characters 100' })
});
